<template>
  <div id="app">
    <template v-if="signedIn">
      <template v-if="isAdviser">
        <HeaderItem :signedIn="true" :isAdviser="true" :isStaff="false" :id="id" />
      </template>
      <template v-else-if="isStaff">
        <HeaderItem :signedIn="true" :isAdviser="false" :isStaff="true" :id="id" />
      </template>
      <template v-else>
        <HeaderItem :signedIn="true" :isAdviser="false" :isStaff="false" :id="id" />
      </template>
    </template>
    <template v-else>
      <template v-if="isAdviser">
        <HeaderItem :signedIn="false" :isAdviser="true" :isStaff="false" :id="id" />
      </template>
      <template v-else>
        <HeaderItem :signedIn="false" :isAdviser="false" :isStaff="false" :id="id" />
      </template>
    </template>
    <main class="common-main">
      <div class="item">
        <h2 class="common-title">お知らせ</h2>
        <!-- 認証済みの時はメインの画面を表示 -->
        <template v-if="signedIn">
          <template v-if="isLoading">
            <div class="loading"></div>
          </template>
          <div v-else-if="hasUserData">
            <!-- TODO：お知らせモジュール(未実装：期間出し分け・通知個別対象絞り込み・ソート) -->
              <div class="item" v-for="information in informationData" :key="information.id">
                <dl class="info">
                  <dt class="info-dt">
                    <span class="info-title">{{information.notificationType}}</span>
                    <span class="info-date">
                      【
                      <template v-if="information.notificationTargetGroup === 'all'">
                        全体向け
                      </template>
                      <template v-if="information.notificationTargetGroup === 'adviser'">
                        <template v-if="information.isForIndividuals">【個別】</template>アドバイザー向け
                      </template>
                      <template v-if="information.notificationTargetGroup === 'user'">
                        <template v-if="information.isForIndividuals">【個別】</template>ユーザー向け
                      </template>
                      】
                      {{information.notificationStartDate | date}}
                    </span>
                  </dt>
                  <dd class="info-dd">
                    {{information.notificationText}}
                    <a v-if="information.notificationUrl" :href="information.notificationUrl"><br>▶関連リンク</a>
                  </dd>
                </dl>
              </div>
          </div>

          <div class="text-box" v-else>
            アカウント情報を設定してください
            <a class="link-button" href="/profileSetting">アカウント設定</a>
          </div>
        </template>

        <!-- 認証していない時はログイン画面を表示 -->
        <template v-else>
          <LoginItem :createButton="false" />
        </template>
      </div>
    </main>
    <template v-if="isAdviser || isStaff">
      <FooterItem :contactUrl="contactUrl" :hiddenFooterFixedButton="true" />
    </template>
    <template v-else>
      <FooterItem :contactUrl="contactUrl" />
    </template>
    
  </div>
</template>

<script>
import { API, Auth, graphqlOperation, Analytics/*, Logger*/ } from 'aws-amplify'
//import { AmplifyEventBus } from 'aws-amplify-vue'
import HeaderItem from './Header'
import FooterItem from './Footer'
import LoginItem from './Login'

import { listUsersBySpecificUser } from './graphql/queries'
import { listInformationsBySpecificNotificationTargetGroup } from './graphql/queries'
import { listStaffAllowListsBySpecificUser } from './graphql/queries'
import { Common } from './Common.js'
import { onAuthUIStateChange } from '@aws-amplify/ui-components';

//const logger = new Logger('NoticeList');
//window.LOG_LEVEL = 'VERBOSE'
//logger.info('info bar');
//logger.debug('debug bar');
//logger.warn('warn bar');
//logger.error('error bar');
Analytics.autoTrack('pageView', {
  enable: true,
  eventName: 'pageView',
  type: 'multiPageApp',
  provider: 'AWSPinpoint',
  getUrl: () => {
    return window.location.origin + window.location.pathname;
  }
});

export default {
  name: 'noticeList',
  components: {
    HeaderItem,
    FooterItem,
    LoginItem
  },
  mixins:[Common],
  data() {
    return {
      authState: undefined,
      unsubscribeAuth: undefined,
      signedIn: false,
      id: '',
      mailaddress: '',
      userId: '',
      userType: '',
      isAdviser: false,
      isStaff: false,
      hasUserData: false,
      informationData: [],
      contactUrl: '',
      isLoading: true
    }
  },
  filters: {
    date: function (value) {
      var valueDate = new Date(value)
      var valueFormat = 'YYYY-MM-DD HH:mm'
      valueFormat = valueFormat.replace(/YYYY/, valueDate.getFullYear())
      
      if (valueDate.getMonth() + 1 < 10) {
        valueFormat = valueFormat.replace(/MM/, '0' + (valueDate.getMonth() + 1))
      } else {
        valueFormat = valueFormat.replace(/MM/, valueDate.getMonth() + 1)
      }
      
      if (valueDate.getDate() < 10) {
        valueFormat = valueFormat.replace(/DD/, '0' + valueDate.getDate())
      } else {
        valueFormat = valueFormat.replace(/DD/, valueDate.getDate())
      }

      if (valueDate.getHours() < 10) {
        valueFormat = valueFormat.replace(/HH/, '0' + valueDate.getHours())
      } else {
        valueFormat = valueFormat.replace(/HH/, valueDate.getHours())
      }

      if (valueDate.getMinutes() < 10) {
        valueFormat = valueFormat.replace(/mm/, '0' + valueDate.getMinutes())
      } else {
        valueFormat = valueFormat.replace(/mm/, valueDate.getMinutes())
      }
      
      return valueFormat
    }
  },

  beforeDestroy() {
    this.unsubscribeAuth();
  },

  async beforeCreate() {
    this.unsubscribeAuth = onAuthUIStateChange(async (authState, authData) => {
      this.authState = authState;
      this.user = authData;
      if (authState === 'signedin') {
        let cognitoUser = await Auth.currentAuthenticatedUser()
        this.signedIn = true
        this.id = cognitoUser.username

        // TODO: ここで hasUserData の確認処理をキックし、リロードの要不要を判定
        location.reload(1)
      } else if (authState === 'signedout') {
        // ログアウト前の情報を破棄
        this.$destroy()
        location.reload(1)
      } else {
        this.signedIn = false
      }
    });
    
    // Auth.currentAuthenticatedUser()でユーザ情報を取得する。
    // 取得できなければ認証ステータスをfalseに設定する
    try {
      let cognitoUser = await Auth.currentAuthenticatedUser()
      this.signedIn = true
      this.id = cognitoUser.username
      this.mailaddress = cognitoUser.attributes.email
    } catch (err) {
      this.signedIn = false
    }

    // 認証情報でUserデータを確認
    try {
      let userData = await API.graphql(
        graphqlOperation(listUsersBySpecificUser, { mailAddress: this.mailaddress, limit: 1 })
      )
      this.userId = userData.data.listUsersBySpecificUser.items[0].id
      this.userType = userData.data.listUsersBySpecificUser.items[0].type
      if (userData.data.listUsersBySpecificUser.items[0].type === 'adviser') {
        this.isAdviser = true
      } else {
        this.isAdviser = false
      }

      if (userData.data.listUsersBySpecificUser.items[0].id) {
        this.hasUserData = true
      }
      let env = this.getEnv(location.hostname)
      this.appClass = this.getAppDivClass(location.hostname)
      if (this.appClass === 'hama') {
        this.contactUrl = 'https://share.hsforms.com/1qOJQdDxdSbSqrkrMw8jeFA46sq5?cancerwith_userid=' + this.id + '&cancerwith_env=' + env // 浜松オンラインがん相談版
      } else {
        this.contactUrl = 'https://share.hsforms.com/1Bs-IcJO-TJOoLtoLHONvYQ46sq5?cancerwith_userid=' + this.id + '&cancerwith_env=' + env // CancerWith版
      }
    } catch (err) {
      // 運営アカウントか判定
      try {
        let staffAllowData = await API.graphql(
          graphqlOperation(listStaffAllowListsBySpecificUser, {
            mailAddress: this.mailaddress,
            limit: 1
          })
        )
        if (
          staffAllowData.data.listStaffAllowListsBySpecificUser.items[0].mailAddress ===
          this.mailaddress
        ) {
          // 運営モード
          this.userId = ''
          this.userType = 'adviser'
          this.isAdviser = false
          this.isStaff = true
          this.hasUserData = true
          this.contactUrl = ''
        } else {
          this.userId = ''
          this.userType = ''
          this.isAdviser = false
          this.isStaff = false
          this.hasUserData = false
          this.contactUrl = ''
        }
      } catch (err) {
        this.userId = ''
        this.userType = ''
        this.isAdviser = false
        this.isStaff = false
        this.hasUserData = false
        this.contactUrl = ''
        this.$router.push({ path: '../dashboard' })
      }
    }

    // お知らせ情報を取得
    try {
      // user or adviser
      let informationDataTarget = await API.graphql(
        graphqlOperation(listInformationsBySpecificNotificationTargetGroup, {
          notificationTargetGroup: this.userType,
          limit: 99999
        })
      )
      informationDataTarget =
        informationDataTarget.data.listInformationsBySpecificNotificationTargetGroup.items

      // 運営用 (typeがadviserなのでuser文も追加)
      if (this.isStaff) {
        let tmpInformationDataTarget = await API.graphql(
          graphqlOperation(listInformationsBySpecificNotificationTargetGroup, {
            notificationTargetGroup: 'user',
            limit: 99999
          })
        )
        tmpInformationDataTarget =
          tmpInformationDataTarget.data.listInformationsBySpecificNotificationTargetGroup.items
        informationDataTarget = informationDataTarget.concat(tmpInformationDataTarget)
      }

      // all
      let informationDataAll = await API.graphql(
        graphqlOperation(listInformationsBySpecificNotificationTargetGroup, {
          notificationTargetGroup: 'all',
          limit: 99999
        })
      )
      informationDataAll =
        informationDataAll.data.listInformationsBySpecificNotificationTargetGroup.items

      this.informationData = informationDataTarget.concat(informationDataAll)
      
      this.informationData.sort (function(a, b) {
        if (new Date(a.notificationStartDate) > new Date(b.notificationStartDate)) {
          return -1
        } else {
          return 1
        }
      })

      var tmpInformationData = []
      for (var key in this.informationData) {
        var isActive = true

        // お知らせ対象出し分け
        var notificationTargetDetail = JSON.parse(this.informationData[key].notificationTargetDetail)
        this.informationData[key].isForIndividuals = false
        if (notificationTargetDetail.indexOf('all') !== -1) {
          isActive = true
        } else if (notificationTargetDetail.indexOf(this.userId) !== -1) {
          this.informationData[key].isForIndividuals = true
          isActive = true
        } else {
          isActive = false
        }

        // 期間出し分け
        var now = new Date()
        now = now.getTime()
        var start = Date.parse(this.informationData[key].notificationStartDate)
        var end = Date.parse(this.informationData[key].notificationEndDate)
        if (start < now && now < end && isActive) {
          isActive = true
        } else {
          isActive = false
        }
          
        if (isActive) {
          tmpInformationData.push(this.informationData[key])
        }
      }
      this.informationData = tmpInformationData
      this.isLoading = false


    } catch (err) {
      this.informationData = []
      this.isLoading = false
    }

    Analytics.record({
      name: 'accessLog', 
      attributes: { 
        page: 'NoticeList',
        url: window.location.origin + window.location.pathname,
        userid: this.id,
        userType: this.userType
      }
    });

    // GA
    if (location.hostname === 'cancerwith.com') {
      if (this.userType === 'user') {
        this.$gtag.pageview({
          page_path: '/user/noticeList',
          page_title: 'User:お知らせ一覧 (/noticeList)'
        })
      } else if (this.userType === 'adviser') {
        this.$gtag.pageview({
          page_path: '/adviser/noticeList',
          page_title: 'Adviser:お知らせ一覧 (/noticeList)'
        })
      }
    }
  }
}
</script>
